<div>
  <ng-template libInput></ng-template>
</div>
